import { useState } from "react"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import './styles/faq.scss';
export default function Faq() {
  const [tab, setTab] = useState(0)

  return (
    <main className="faq">
      <h2>Frequently Asked Questions</h2>
      <section className="tabs">
        <h4>How Do I Get Started with the Course? {tab != 1 ? <ExpandMoreIcon onClick={() => setTab(1)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 1 ? (
          <p>You’ll receive instant access to our private vault, where all the online modules, additional bonuses,
            and resources are waiting for you.</p>
        ) : null}
        <hr />
        <h4>Where Does The Programme Take Place? {tab != 2 ? <ExpandMoreIcon onClick={() => setTab(2)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 2 ? (
          <p>The entire programme is online, so you can participate from home or work at your own pace. All
            materials are accessible through our online portal on any device.</p>
        ) : null}
        <hr />
        <h4>How Long Do I Have Access To The Course? {tab != 3 ? <ExpandMoreIcon onClick={() => setTab(3)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 3 ? (
          <p>You'll have access to the online course for life, allowing you plenty of time to go through the
            course material at your own pace.</p>
        ) : null}
        <hr />
        <h4>How Do I Access The Course Content? {tab != 4 ? <ExpandMoreIcon onClick={() => setTab(4)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 4 ? (
          <p>Upon purchase, you will receive login details via email. One email will be an instruction email from
            PMW, and another will be from the Skool platform with your login details. Use the login details to
            access the course content through our online portal, available on any device.</p>
        ) : null}
        <hr />
        <h4>How Do I Work My Way Through The Course? {tab != 5 ? <ExpandMoreIcon onClick={() => setTab(5)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 5 ? (
          <p>The first module ‘START HERE’ in the online portal is where you should start and then gradually
            work your way through each of the following modules in order.</p>
        ) : null}
        <hr />
        <h4>Is The Content Available On Mobile Devices? {tab != 6 ? <ExpandMoreIcon onClick={() => setTab(6)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 6 ? (
          <p>Yes, all course materials are fully accessible on mobile devices through our app, as well as on
            tablets and desktops, allowing you to learn conveniently from anywhere.</p>
        ) : null}
        <hr />
        <h4>Do I Get Updates To The Course Content? {tab != 7 ? <ExpandMoreIcon onClick={() => setTab(7)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 7 ? (
          <p>Yes, you will automatically receive any updates or new content added to the course during your
            access period.</p>
        ) : null}
        <hr />
        <h4>What If I Need Help Or Have Questions? {tab != 8 ? <ExpandMoreIcon onClick={() => setTab(8)} /> : <ExpandLessIcon onClick={() => setTab(0)} />}</h4>
        {tab == 8 ? (
          <>
            <p>For any issues with your account or programme access, you can use the “PMW Helpdesk” link
              inside the online portal. Or you can reach out to Team PMW on the following channels:</p>
              <ul>
                <li><a href='tel:08002335596'>Phone: 0800 233 5596</a></li>
                <li><a href='mailto:mail@teampmw.com'>Email: mail@teampmw.com</a></li>
                <li>WhatsApp/Text: 07893 945233</li>
              </ul>
          </>
        ) : null}
        <hr />

      </section>
    </main>
  )
}